import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Team from 'components/Dashboard/Modules/Team';
import { AppState } from 'reducers/reducers';
import Loader from 'components/Loader/Loader';
import { useTeam } from 'contexts/TeamContext';

type TeamModuleContainerProps = ReturnType<typeof mapStateToProps>;

function TeamModuleContainer({ organization }: TeamModuleContainerProps) {
    const { getTeam, team, loading } = useTeam();

    useEffect(() => {
        getTeam(organization.pk);
    }, [organization, getTeam]);

    const active = !!team && !loading;
    return <div>{active ? <Team organization={organization} /> : <Loader />}</div>;
}

function mapStateToProps(state: AppState) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        organization: state.organization.organization!,
    };
}

export default connect(mapStateToProps, {})(TeamModuleContainer);
